import { render } from "./StackTransactionsTbl.vue?vue&type=template&id=ea815076"
import script from "./StackTransactionsTbl.vue?vue&type=script&lang=js"
export * from "./StackTransactionsTbl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__